import React, {useContext, useEffect, useMemo, useState} from "react";
import Navbar from "../../../../common/layout/Navbar";
import {
  empType,
  ExportTypes,
  LicenseTypes,
  MapPageFor,
  Operation,
  PriorityEnum,
  TimeZone,
} from "../../../../../utils/Enum.types";
import {Title} from "../../../../../stories/Title/Title";
import {MapsContext} from "../context/context";
import {
  debouncedDelay,
  DEFAULT_TIME,
  EMPTY_STRING,
  emptyFunc,
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  ticketPriorirityOptions,
  TicketStatus,
  ticketStatusOptions,
} from "../../../../../utils/constants";
import {TABLE_ROW_HEIGHT} from "../../../../../styles/Variables";
import Input from "../../../../../stories/Input/Input";
import {
  convertToTimeZone,
  CustomModal,
  ticketPriorityClassName,
  ticketStatusClassName,
  toInputStandardDate,
  toIsoDate,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import {StyledDatagrid} from "../../../../../styles/DatagridStyles";

import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid-pro";
import {
  PriorityOptionsTypes,
  TicketStatusOptionsTypes,
  TableHeaderProps,
} from "../../../../../utils/types";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import EyeWhite from "../../../../../images/EyeWhite.svg";
import Compare from "../../../../../images/Compare.svg";
import {Button} from "../../../../../stories/Button/Button";
import {useNavigate} from "react-router-dom";
import {
  ViewRaisedTicketModalStyles,
  WaiveOffModalStyles,
} from "../../../../../styles/CustomModalStyles";
import AssetTableView from "./AssetTableView";
import DownloadDoc from "../../../../../images/DocumentsDownload.svg";

import {
  AtsTicketsOrderField,
  GetTicketsData,
  GetTicketsVars,
  TicketEdge,
  TicketsQueryType,
} from "../../../../../queries/types";
import {GetTickets} from "../../../../../queries/queries";
import {useLazyQuery} from "@apollo/client";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import {OrderDirection} from "../../../../../utils/commonQueryTypes";
import {IObjectKeys, responseType} from "../../../../../utils/formTypes";
import ItemsAutocomplete from "../../../../../customComponents/ItemsAutocomplete";

import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import useLabels from "../../../../../customHooks/useLabels";
import TicketErrorMsgSelect from "../../../../../customComponents/TicketErrorMsgSelect";
import {StateTypes} from "../Maps";
import {mapsPayloadType} from "../context/reducer";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import MultipleTicketStatusSelect from "../../../../../customComponents/MultipleTicketStatusSelect";
import MultiplePrioritySelect from "../../../../../customComponents/MultiplePrioritySelect";
import Close from "../../../../../images/Close.svg";
import dayjs from "dayjs";
import RaisedTicketDetails from "../ticketing/junctionDetails/raisedTickets/RaisedTicketDetails";
import {TableType} from "../../../customer/companies/queries/types";
import {AssetDetailsPageFor} from "../ticketing/junctionDetails/raisedTickets/AssetDetails";
import {ExportTickets} from "../queries/queriers";
import {ExportTicketsResult, ExportTicketsVariables} from "../queries/types";
import {getDownloadUrl} from "../../../../../utils/DownloadFile";
import MessageModal from "../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../pages/LoadingModal";
import SuppliersSelect from "../../purchase/purchaseorder/rfqtopo/components/SuppliersSelect";
import {LdgrQueryType} from "../../masters/supplier/queries/types";
import {ColumnVisibilityFor} from "../../../../../utils/Enum.Datagrid";
import {AppContext} from "../../../../../context/context";
import { useDebounce } from "../../../../../customHooks/useDebounce";
export interface NavTypeProps {
  NavType: LicenseTypes;
  pageFor: MapPageFor;
  ticketStatusType: TicketStatus;
  ticketPriority: PriorityEnum;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface FilterBarProps extends IObjectKeys {
  searchData: string;
  asset: number;
  ticketReason: string;
  assetStatus: string;
  priority: string;
  ticketStatus: string;
  fromDate: string;
  endDate: string;
  subsidiary: number;
}

const TicketsRaisedList = ({
  NavType,
  pageFor,
  ticketStatusType,
  ticketPriority,
  setModalFlag,
}: NavTypeProps) => {
  const {state, dispatch: mapsDispatch} = useContext(MapsContext);
  const {state: globalState} = useContext(AppContext);

  const {Maps} = useAssetTableJson();
  const navigate = useNavigate();
  const [viewDetails, setViewDetails] = useState(false);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [searchData, setSearchData] = useState<string>("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);

  const [vendor, setVendor] = useState<responseType | null>(null);
  const [exportModal, setExportModal] = useState(false);
  const [exportFormat, setExportFormat] = useState<ExportTypes>(
    ExportTypes.EXCEL
  );
  const {ledgerLabel} = useLabels();

  const [raisedTicketModal, setRaisedTicketModal] = useState<StateTypes>({
    itemId: 0,
    flag: false,
    tableLevel: TableType.COMPANY,
  });

  const {user_details} = useLoggedInUserDetails();

  const [Export, {loading: exportLoading}] = useLazyQuery<
    ExportTicketsResult,
    ExportTicketsVariables
  >(ExportTickets, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [message, setMessage] = useState(emptyMessage);

  const [filterFormData, setFilterFormData] = useState<FilterBarProps>({
    asset: 0,
    assetStatus: "",
    priority: "",
    searchData: "",
    ticketReason: "",
    ticketStatus: "",
    date: "",
    subsidiary: 0,
    endDate: "",
    fromDate: "",
  });
  const [statusSelected, setStatusSelected] = useState<
    TicketStatusOptionsTypes[]
  >([]);

  const [prioritySelected, setPrioritySelected] = useState<
    PriorityOptionsTypes[]
  >([]);

  useEffect(() => {}, []);
  const {company_id, customer_id, sub_id} = useUrlParams();
  const {serverDate} = useServerDateandTime();

  const [tickets, setTickets] = useState<TicketEdge[]>([]);

  const dynamicHeaders: TableHeaderProps[] = Maps.RaisedTicketDetails.filter(
    (header) => header.field !== "actions"
  ).map((header) => ({
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    renderCell: (params) => {
      if (header.field === "actions") {
        return (
          <>
            <button
              className="tkt-raised-list__tableblock--view"
              onClick={() => setViewDetails(!viewDetails)}
            >
              View Details <img src={EyeWhite} alt="" />
            </button>
          </>
        );
      } else if (header.field === "priority") {
        return (
          <>
            <div
              style={{margin: "auto"}}
              className={ticketPriorityClassName(params.row.priority)}
            >
              {params.row.priority}
            </div>
          </>
        );
      } else if (header.field === "attachments") {
        return (
          <>
            <div className={`tkt-raised-list__tableblock--attachments`}>
              {params.row.attachments} <img src={DownloadDoc} alt="" />
            </div>
          </>
        );
      } else if (header.field === "ticket_status") {
        return (
          <>
            <span className={ticketStatusClassName(params.row.ticket_status)}>
              {params.row.ticket_status}
            </span>
          </>
        );
      } else return params.value;
    },
  }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const [GetTicket, {data, loading, fetchMore}] = useLazyQuery<
    GetTicketsData,
    GetTicketsVars
  >(GetTickets);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetTickets.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCustomer) => {
          const filteredStudent = tickets.find(
            (ticket) => ticket.node.id === newCustomer.node.id
          );
          if (filteredStudent) {
            return {
              ...newCustomer,
              node: {
                ...newCustomer.node,
              },
            };
          }
          return newCustomer;
        });

        setTickets(updatedNewData);
      } else {
        setTickets(newData);
      }

      setEndCursor(data.GetTickets.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [loading, data]);

  useEffect(() => {
    if (ticketStatusType === TicketStatus.ALL) {
      setStatusSelected([]);
    } else
      setStatusSelected(
        ticketStatusOptions.filter((item) => item.value === ticketStatusType)
      );
  }, [ticketStatusOptions, ticketStatusType]);

  useEffect(() => {
    if (ticketPriority === PriorityEnum.ALL) {
      setPrioritySelected([]);
    } else
      setPrioritySelected(
        ticketPriorirityOptions.filter((item) => item.value === ticketPriority)
      );
  }, [ticketPriorirityOptions, ticketPriority]);

  const rows = useMemo(() => {
    if (!data) return [];
    let filteredData = data.GetTickets.edges;
    return filteredData.map(({node}, index) => ({
      id: index + 1,
      logNo: node.ticketNo,
      asset: node.item.desc,
      asset_slno: node.itemDetails.prodSerialNo,
      ticket_date:
        toStandardDate(node.ticketDate) !== toStandardDate(DEFAULT_TIME)
          ? convertToTimeZone(TimeZone.Asia_Kolkata, node.ticketDate)
              .timeAndDate
          : "-",
      company: node.company.name,
      subsidiary: node.subsidiaryDetails.name,
      subsidiary_site: node.site.name,
      junction: node.junction.name,
      ticket_reason: node.reason,
      status: node.status,
      maintained_by: node.vendorDetails.desc,
      attachments: "",
      priority: node.priority,
      ticket_status: node.status,
      ticket_id: node.id,
      asset_id: node.itemDetails.id,
      tableLevel: node.tableLevel,
      poleNum: node.poleNum,

      closedDate:
        toStandardDate(node.closedDate) !== toStandardDate(DEFAULT_TIME)
          ? convertToTimeZone(TimeZone.Asia_Kolkata, node.closedDate)
              .timeAndDate
          : "-",
      tableId:
        node.tableLevel === TableType.ASSET
          ? node.itemDetails.id
          : node.junctionID,
      closedDuration: node.closedDuration,
      address: node.itemDetails.address
    }));
  }, [data, pageFor]);

  const handleScroll = () => {
    if (hasNextPage && !loading) {
      fetchMore({
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: (prevResult, {fetchMoreResult}) => {
          if (!fetchMoreResult) return prevResult;

          const newEdges = fetchMoreResult.GetTickets.edges;
          const pageInfo = fetchMoreResult.GetTickets.pageInfo;

          setEndCursor(pageInfo.endCursor);
          setHasNextPage(pageInfo.hasNextPage);

          const duplicateCheck = prevResult.GetTickets
            ? prevResult.GetTickets.edges.filter(
                ({node: {id}}) =>
                  newEdges.findIndex(({node: {id: newId}}) => newId === id) !==
                  -1
              )
            : [];

          if (duplicateCheck.length > 0) return prevResult;

          return {
            GetTickets: {
              edges: [...tickets, ...newEdges],
              pageInfo,
              totalCount: data ? data.GetTickets.totalCount! : 0,
            },
          };
        },
      });
    }
  };

  useEffect(() => {
    if (customer_id) {
      GetTicket({
        variables: {
          after: null,
          first: ROWS_PER_PAGE,
          name: debouncedSearch,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsTicketsOrderField.TICKET_NO,
          },

          companyID: company_id ? company_id : 0,
          customerID: customer_id,
          subsidiaryID: sub_id ? sub_id : 0,
          junctionID: 0,
          reason: filterFormData.ticketReason,
          startDate: filterFormData.fromDate
            ? toIsoDate(filterFormData.fromDate)
            : undefined,
          endDate: filterFormData.endDate
            ? toIsoDate(filterFormData.endDate)
            : undefined,
          input: {
            itemID: filterFormData.asset,
            ldgrID: vendor ? vendor.value : 0,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckSubCategoryID: 0,
            stckUomID: 0,
            query_type: TicketsQueryType.ALL,
            itemDetailsID: 0,
            status: statusSelected.map(({value}) => value),
            priority: prioritySelected.map(({value}) => value),
            empID: user_details.id!,
          },
          siteID: 0,
        },
      });
    }
  }, [
    GetTicket,
    debouncedSearch,
    company_id,
    customer_id,
    sub_id,
    filterFormData.asset,
    filterFormData.ticketReason,
    filterFormData.fromDate,
    filterFormData.endDate,
    ticketStatusType,
    ticketPriority,
    statusSelected,
    prioritySelected,
    user_details.id,
  ]);

  useEffect(() => {
    if (serverDate) {
      setFilterFormData({
        ...filterFormData,
        // fromDate: toInputStandardDate(serverDate),
        endDate: toInputStandardDate(serverDate),
      });
    }
  }, [serverDate]);

  const {itemLabel} = useLabels();

  const handleExport = async () => {
    if (customer_id) {
      Export({
        variables: {
          companyID: state.companyId,
          customerID: customer_id,
          startDate: filterFormData.fromDate
            ? toIsoDate(filterFormData.fromDate)
            : undefined,
          endDate: filterFormData.endDate
            ? toIsoDate(filterFormData.endDate)
            : undefined,
          siteID: 0,
          subsidiaryID: sub_id ? sub_id : 0,

          input: {
            itemID: filterFormData.asset,
            ldgrID: 0,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckSubCategoryID: 0,
            stckUomID: 0,
            query_type: TicketsQueryType.ALL,
            itemDetailsID: 0,
            status: statusSelected.map(({value}) => value),
            priority: prioritySelected.map(({value}) => value),
            empID: user_details.id!,
          },
          format: exportFormat,
        },
      }).then(async ({data}) => {
        if (data && data.ExportTickets) {
          const res = await getDownloadUrl(data.ExportTickets, true);
          if (res) {
            setMessage({
              flag: true,
              message: "Downloading...",
              operation: Operation.CREATE,
            });
          }
        }
      });
    }
  };
  const [columnVisibilityModel, setColumnVisibilityModel] =
    React.useState<GridColumnVisibilityModel>({
      id: true,
      ticket_date: true,
      logNo: true,
      company: false,
      subsidiary: false,
      subsidiary_site: false,
      asset: false,
      poleNum: false,
      ticket_reason: false,
      maintained_by: false,
      resolvedDate: true,
      closedDate: false,
      ticket_status: true,
      priority: true,
      resolvedDuration: false,
      closedDuration: false,
      actions: false,
    });

  useEffect(() => {
    const savedVisibilityModel = localStorage.getItem(
      ColumnVisibilityFor.TICKET_LIST
    );
    if (savedVisibilityModel) {
      setColumnVisibilityModel(JSON.parse(savedVisibilityModel));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      ColumnVisibilityFor.TICKET_LIST,
      JSON.stringify(columnVisibilityModel)
    );
  }, [columnVisibilityModel]);
  return (
    <>
      {pageFor === MapPageFor.MODAL ? null : <Navbar NavType={NavType} />}
      <div className="tkt-raised-list__title">
        <Title>
          {pageFor === MapPageFor.TICKET
            ? "Tickets Raised"
            : pageFor === MapPageFor.MODAL
            ? "Ticket List"
            : `${itemLabel} List`}
        </Title>
        {pageFor === MapPageFor.MODAL && (
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        )}
      </div>

      <div
        className={`tkt-raised-list${
          pageFor === MapPageFor.MODAL ? "--modal" : ""
        }`}
      >
        {/* {pageFor === MapPageFor.MODAL ? null : (
          <div className="tkt-raised-list__row row g-0">
            {!sub_id ? (
              <div className="col-3">
                <SubsidiarySelect
                  onChange={(newValue) => {
                    if (newValue) {
                      setFilterFormData({
                        ...filterFormData,
                        subsidiary: newValue.node.id
                      });
                    } else {
                      setFilterFormData({
                        ...filterFormData,
                        subsidiary: 0
                      });
                    }
                  }}
                  label={subsidiaryLabel}
                  companyID={company_id ? company_id : 0}
                  onKeyDown={emptyFunc}
                  value={state.subsidary ? state.subsidary.node.id : 0}
                />
              </div>
            </div>
          ) : null}

            <Tabs
              active={
                pageFor === MapPageFor.TICKET
                  ? TabType.TICKET_RAISED
                  : TabType.ITEMS
              }
              pageFor={pageFor}
            />
          </div>
        )} */}

        {pageFor === MapPageFor.TICKET || pageFor === MapPageFor.MODAL ? (
          <>
            <div className="tkt-raised-list__select row g-0">
              <div className="col">
                <Input
                  id="data_search"
                  placeholder="Search..."
                  onChange={(e) => setSearchData(e.target.value)}
                />
              </div>
              <div className="col">
                <ItemsAutocomplete
                  onChange={(newValue) => {
                    if (newValue) {
                      setFilterFormData({
                        ...filterFormData,
                        asset: newValue.value,
                      });
                    } else {
                      setFilterFormData({
                        ...filterFormData,
                        asset: 0,
                      });
                    }
                  }}
                  onKeyDown={emptyFunc}
                  value={filterFormData.asset}
                  label={itemLabel}
                  placeholder=""
                />
              </div>
              <div className="col">
                <TicketErrorMsgSelect
                  onChange={(newValue) => {
                    if (newValue) {
                      setFilterFormData({
                        ...filterFormData,
                        ticketReason: newValue,
                      });
                    } else {
                      setFilterFormData({
                        ...filterFormData,
                        ticketReason: EMPTY_STRING,
                      });
                    }
                  }}
                  value={filterFormData.ticketReason}
                  label="Ticket Reason"
                  itemId={filterFormData.asset}
                  itemDetailsId={0}
                />
              </div>
              {/* <div className="col">
                <AssetStatusSelect
                  onChange={(newValue) => {
                    if (newValue) {
                      setFilterFormData({
                        ...filterFormData,
                        assetStatus: newValue
                      });
                    } else {
                      setFilterFormData({
                        ...filterFormData,
                        assetStatus: EMPTY_STRING
                      });
                    }
                  }}
                  value={filterFormData.assetStatus}
                  label={`${itemLabel} Status`}
                />
              </div> */}
              <div className="col tkt-raised-list__select--multi-select">
                <MultiplePrioritySelect
                  onChange={(newValue) => {
                    setPrioritySelected(newValue);
                  }}
                  onKeyDown={emptyFunc}
                  autoCompleteValue={prioritySelected}
                  handleClear={emptyFunc}
                  // value={statusSelected.map((status) => status.value)}
                  label="Ticket Priority"
                />
              </div>
              <div className="col  tkt-raised-list__select--multi-select">
                <MultipleTicketStatusSelect
                  onChange={(newValue) => {
                    setStatusSelected(newValue);
                  }}
                  onKeyDown={emptyFunc}
                  value={statusSelected}
                  handleClear={emptyFunc}
                  label="Ticket Status"
                />
              </div>
              {globalState.empSubType !== empType.VENDOR_MANAGER && (
                <div className="col">
                  <SuppliersSelect
                    onChange={(newValue) => {
                      if (newValue) setVendor(newValue);
                      else setVendor(null);
                    }}
                    onKeyDown={emptyFunc}
                    value={vendor ? vendor.value : 0}
                    label={ledgerLabel}
                    input={{
                      itemID: 0,
                      query_type: LdgrQueryType.ALL,
                      tableLevel: TableType.CUSTOMER,
                    }}
                  />
                </div>
              )}
              <div className="col">
                <div className="tkt-raised-list__select--flex">
                  <TextField
                    label="From date"
                    className="tkt-raised-list__select--textfield"
                    slotProps={{
                      inputLabel: {shrink: true},
                    }}
                    type="date"
                    onChange={(e) => {
                      if (
                        dayjs(e.target.value).isAfter(
                          dayjs(filterFormData.endDate)
                        )
                      ) {
                        return;
                      }
                      setFilterFormData({
                        ...filterFormData,
                        fromDate: e.target.value,
                      });
                    }}
                    value={filterFormData.fromDate}
                  />
                  <img
                    src={Compare}
                    alt=""
                    onClick={() => {
                      setFilterFormData({
                        ...filterFormData,
                        fromDate: toInputStandardDate(filterFormData.endDate),
                        endDate: toInputStandardDate(filterFormData.fromDate),
                      });
                    }}
                  />

                  <TextField
                    label="To date"
                    className="tkt-raised-list__select--textfield"
                    slotProps={{
                      inputLabel: {shrink: true},
                    }}
                    type="date"
                    onChange={(e) => {
                      if (
                        dayjs(e.target.value).isBefore(
                          dayjs(filterFormData.fromDate)
                        )
                      ) {
                        return;
                      }
                      setFilterFormData({
                        ...filterFormData,
                        endDate: e.target.value,
                      });
                    }}
                    value={filterFormData.endDate}
                  />
                </div>
              </div>
            </div>
            <div className="tkt-raised-list__tableblock">
              <StyledDatagrid
                columns={columns}
                rows={rows}
                rowHeight={TABLE_ROW_HEIGHT}
                onCellClick={(params) => {
                  if (params.field !== "id") {
                    mapsDispatch({
                      type: mapsPayloadType.ASSET,
                      payload: {
                        asset: {
                          label: EMPTY_STRING,
                          value: params.row.asset_id,
                        },
                      },
                    });

                    mapsDispatch({
                      type: mapsPayloadType.TICKET,
                      payload: {
                        ticketId: params.row.ticket_id,
                      },
                    });
                    mapsDispatch({
                      type: mapsPayloadType.ASSET_TYPE_ID,
                      payload: {
                        assetTypeId: params.row.tableId,
                      },
                    });

                    setRaisedTicketModal({
                      flag: true,
                      itemId: params.row.asset_id,
                      tableLevel: params.row.tableLevel,
                    });
                  }
                }}
                disableRowSelectionOnClick
                hideFooter
                onRowsScrollEnd={() => {
                  handleScroll();
                }}
                initialState={{
                  pinnedColumns: {
                    left: ["id", "ticket_no", "asset", "asset_id"],
                    right: ["priority", "ticket_status", "actions"],
                  },
                }}
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={(newModel) =>
                  setColumnVisibilityModel(newModel)
                }
              />
            </div>
            <div className="row g-0">
              <div className="col">
                <Button
                  mode="excel"
                  onClick={() => setExportModal(!exportModal)}
                >
                  Export
                </Button>
                {pageFor === MapPageFor.MODAL ? (
                  <Button mode="cancel" onClick={() => setModalFlag(false)} />
                ) : (
                  <Button mode="back" onClick={() => navigate(-1)} />
                )}
              </div>
              <div className="col flex-end">
                <div className="overall-total-count">
                  Total Tickets :{" "}
                  <b>{data ? data.GetTickets.totalCount : 0}</b>
                </div>
              </div>
            </div>
          </>
        ) : (
          <AssetTableView
            sub_id={sub_id ? sub_id : filterFormData.subsidiary}
          />
        )}
      </div>

      {/* <CustomModal
        style={ViewAssetStyles}
        isOpen={assetDetails.flag}
        onRequestClose={() =>
          setAssetdetails({
            flag: false,
            itemId: 0,
          })
        }
        contentComponent={
          <Ticketing
            setModalFlag={() =>
              setAssetdetails({
                flag: false,
                itemId: 0,
              })
            }
            showRaiseTicket={globalState.empSubType !== empType.TECHNICIAN}
          />
        }
      /> */}

      {/* <CustomModal
        style={ViewTicketModalStyles}
        isOpen={raisedTicketModal.flag}
        onRequestClose={() =>
          setRaisedTicketModal({
            flag: false,
            itemId: 0,
          })
        }
        contentComponent={
          <RaisedTicketDetails
            setModalFlag={() =>
              setRaisedTicketModal({
                flag: false,
                itemId: 0,
              })
            }
          />
        }
      /> */}

      <CustomModal
        style={ViewRaisedTicketModalStyles}
        isOpen={raisedTicketModal.flag}
        onRequestClose={() =>
          setRaisedTicketModal({
            flag: false,
            itemId: 0,
            tableLevel: TableType.COMPANY,
          })
        }
        contentComponent={
          <RaisedTicketDetails
            setModalFlag={setRaisedTicketModal}
            pageFor={AssetDetailsPageFor.DASHBOARD}
            assetType={raisedTicketModal.tableLevel}
          />
        }
      />
      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />

      <CustomModal
        style={WaiveOffModalStyles}
        isOpen={exportModal}
        onRequestClose={() => setExportModal(!exportModal)}
        contentComponent={
          <>
            <div className="choose-export-type">
              <div className="choose-export-type__title">
                <Title>Choose Excel Or Pdf</Title>
                <img
                  src={Close}
                  alt=""
                  onClick={() => setExportModal(!exportModal)}
                />
              </div>
              <div className="choose-export-type__block">
                <FormControl>
                  <RadioGroup
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setExportFormat(e.target.value as ExportTypes)
                    }
                    defaultValue={ExportTypes.EXCEL}
                  >
                    <FormControlLabel
                      control={<Radio />}
                      label="Excel"
                      value={ExportTypes.EXCEL}
                    />
                    <FormControlLabel
                      value={ExportTypes.PDF}
                      control={<Radio />}
                      label="Pdf"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <Button mode="save" onClick={handleExport} />
              <Button
                mode="cancel"
                onClick={() => setExportModal(!exportModal)}
              />
            </div>
          </>
        }
      />
      <LoadingModal flag={exportLoading} />
    </>
  );
};

export default TicketsRaisedList;
